import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class SignOut extends Component {
  componentWillMount() {
    this.props.signoutUser();
  }
  render() {
    return (
      <div id="sign-out">
        <center>
          <h4>You have been signed out!</h4>
        </center>
      </div>
    );
  }
};

export default connect(null, actions)(SignOut);



// WEBPACK FOOTER //
// ./src/containers/auth/signout.js